import React from "react";
import { Accordion, AccordionDetails, AccordionSummary, Typography } from "@mui/material";
import { ExpandMoreRounded as ExpandIcon, Settings } from "@mui/icons-material";
import { useSelector } from "react-redux";

const settingsItemsConfig = [{ permission: 42, label: "System Settings", to: "/settings" }];

const SidebarSettingsDropdown = ({ activeDropdown, user, RouterLink }) => {
  const color = useSelector((state) => state.theme);
  const isActiveDropdown = Boolean(activeDropdown?.match(/application/gi));

  return (
    <Accordion elevation={0} square disableGutters>
      <AccordionSummary
        className={
          isActiveDropdown
            ? `FstoSidebarActiveDropdown-root ${color}`
            : `FstoSidebarDropdown-root ${color}`
        }
        expandIcon={<ExpandIcon htmlColor="white" />}
      >
        <Settings /> <Typography variant="sidebar">Settings</Typography>
      </AccordionSummary>

      <AccordionDetails className="FstoSidebarAccordionDetails-root">
        {settingsItemsConfig.map(
          (item) =>
            user.permissions.includes(item.permission) && (
              <RouterLink className="FstoSidebarLink-root" to={item.to} key={item.label}>
                {item.label}
              </RouterLink>
            )
        )}
      </AccordionDetails>
    </Accordion>
  );
};

export default SidebarSettingsDropdown;
